import SocialIcon from 'components/misc/SocialIcon'
import styles from './styles/Endorsement.css'
import P from 'components/typography/Paragraph'

const Endorsement = () => {
  return (
    <blockquote className={styles.blockQuote}>
      <div className={styles.quoteGroup}>
        <P className={styles.quote}>“I cannot express how useful this site has been for me over the last few months👌🏼 would highly recommend 👍”</P>
        <SocialIcon className={styles.tweet} href='https://twitter.com/Chrest_brett/status/1292883084694695936?ref_src=twsrc%5Etfw' type='twitter' />
      </div>
      <div className={styles.details}>
        <div>August 10, 2020</div>
        <div>Brett Chrest (@Chrest_brett)</div>
        <div>Brandon University</div>
      </div>
    </blockquote>
  )
}

export default Endorsement
